export default {
  productsLoading: false,
  products: []
}
